import {
  RESET_DATA,
  RESET_PAYOUT_DASHBOARD_STATE,
  GET_PAYOUT_QUANTITY,
  GET_PAYOUT_QUANTITY_SUCCESS,
  GET_PAYOUT_QUANTITY_FAILED,
  GET_PAYOUT_HEADER,
  GET_PAYOUT_HEADER_SUCCESS,
  GET_PAYOUT_HEADER_FAILED,
  GET_PAYOUT_HEADER_CSV,
  GET_PAYOUT_HEADER_CSV_SUCCESS,
  GET_PAYOUT_HEADER_CSV_FAILED,
  GET_PAYOUT_ITEM_CSV,
  GET_PAYOUT_ITEM_CSV_SUCCESS,
  GET_PAYOUT_ITEM_CSV_FAILED,
  SHOW_ALERT_PAYOUT,
  HIDE_ALERT_PAYOUT,
} from "../actions";

import { payoutHeader } from "../../utils/common";

export const initialState = {
  quantityObj: {
    loading: false,
    error: null,
    data: [],
    qtyData: {},
    tileData: {},
  },
  headerObj: {
    loading: false,
    error: null,
    data: [],
    // hdrData: {},
    tileData: {},
  },
  headerCSVObj: {
    loading: false,
    error: null,
    data: [],
  },
  itemCSVObj: {
    loading: false,
    error: null,
    data: [],
  },
  headerCsvLoading: {
    loading: false,
  },
  lineItemCsvLoading: {
    loading: false,
  },
  showAlert: false,
};

export function payoutReducer(state = initialState, action) {
  switch (action.type) {
    case SHOW_ALERT_PAYOUT: {
      return {
        ...state,
        showAlert: action.component,
      };
    }
    case HIDE_ALERT_PAYOUT: {
      return {
        ...state,
        showAlert: false,
      };
    }
    case RESET_DATA:
    case RESET_PAYOUT_DASHBOARD_STATE:
      return {
        ...state,
        quantityObj: {
          loading: false,
          error: null,
          data: [],
          qtyData: {},
          tileData: {},
        },
        headerObj: {
          loading: false,
          error: null,
          data: [],
          tileData: {},
        },
      };
    case GET_PAYOUT_QUANTITY:
      return {
        ...state,
        quantityObj: {
          loading: true,
          error: null,
          data: [],
          qtyData: state.quantityObj.qtyData,
          tileData: state.quantityObj.tileData,
        },
      };
    case GET_PAYOUT_QUANTITY_SUCCESS:
      //let updatedObj = payoutMapping(action.payload);
      let tileObj = payoutHeader(
        action.params.partnerRoleType,
        action.payload.content
      );
      let testqty = JSON.parse(JSON.stringify(state.quantityObj.qtyData));
      testqty[action.params.urlQuantity] =
        // action.params.moduleName !== "Device Payout"
        //   ? [action.payload.content.QTY] :
          [action.payload.content.qty]; // uncomment the above two lines when header and quantity data comes differently
      // if (action.params.partnerRoleType === "MARD" || action.params.partnerRoleType === "ARD") {
      //     if (action.params.schemeType === "RDS") {
      //         testqty[action.params.urlQuantity] = 0
      //     }
      // }
      let testTile = JSON.parse(JSON.stringify(state.quantityObj.tileData));
      testTile[action.params.urlQuantity] = [tileObj];
      return {
        ...state,
        quantityObj: {
          loading: false,
          error: null,
          //data: action.payload,
          qtyData: Object.assign(state.quantityObj.qtyData, testqty),
          tileData: Object.assign(state.quantityObj.tileData, testTile),
        },
      };

    case GET_PAYOUT_QUANTITY_FAILED:
      return {
        ...state,
        quantityObj: {
          loading: false,
          error: action.error,
          data: [],
          qtyData: {},
          tileData: {},
        },
      };

    case GET_PAYOUT_HEADER:
      return {
        ...state,
        headerObj: {
          loading: true,
          error: null,
          data: [],
          // hdrData: state.headerObj.hdrData,
          tileData: state.headerObj.tileData,
        },
      };

    case GET_PAYOUT_HEADER_SUCCESS:
      return {
        ...state,
        headerObj: {
          loading: false,
          error: null,
          //data: action.payload,
          // hdrData: Object.assign(state.headerObj.hdrData, testhdr),
          tileData: {
            ...state.headerObj.tileData,
            [action.params.urlHeader]: [
              payoutHeader(
                action.params.partnerRoleType,
                action.payload.content
              ),
            ],
          },
        },
      };

    case GET_PAYOUT_HEADER_FAILED:
      return {
        ...state,
        headerObj: {
          loading: false,
          error: action.error,
          data: [],
          // hdrData: {},
          tileData: {},
        },
      };

    case GET_PAYOUT_HEADER_CSV:
      return {
        ...state,
        headerCSVObj: {
          loading: true,
          error: null,
          data: [],
        },
        headerCsvLoading: {
          loading: true,
        },
      };

    case GET_PAYOUT_HEADER_CSV_SUCCESS:
      return {
        ...state,
        headerCSVObj: {
          loading: false,
          error: null,
          data: action.payload,
        },
        headerCsvLoading: {
          loading: false,
        },
      };

    case GET_PAYOUT_HEADER_CSV_FAILED:
      return {
        ...state,
        headerCSVObj: {
          loading: false,
          error: action.error,
          data: [],
        },
        headerCsvLoading: {
          loading: false,
        },
      };
    case GET_PAYOUT_ITEM_CSV:
      return {
        ...state,
        itemCSVObj: {
          loading: true,
          error: null,
          data: [],
        },
        lineItemCsvLoading: {
          loading: true,
        },
      };

    case GET_PAYOUT_ITEM_CSV_SUCCESS:
      return {
        ...state,
        itemCSVObj: {
          loading: false,
          error: null,
          data: action.payload,
        },
        lineItemCsvLoading: {
          loading: false,
        },
      };

    case GET_PAYOUT_ITEM_CSV_FAILED:
      return {
        ...state,
        itemCSVObj: {
          loading: false,
          error: action.error,
          data: [],
        },
        lineItemCsvLoading: {
          loading: false,
        },
      };

    default:
      return state;
  }
}

export default payoutReducer;
